// @flow
import type {Node} from 'react'
import React from 'react'

import Markdown from 'components/ui/Markdown'
import styles from './index.scss'

type Props = {
  tip: string,
}

function ParentTip({tip}: Props): Node {
  return <Markdown className={styles.sectionCaption} source={tip} />
}

export default ParentTip
